import type { IPasswordValidationRule } from "@front-shared/types/objects.types.ts"

import { FRONT_REGEX_CONFIG } from "./regex.config"

export const FRONT_PASSWORD_VALIDATION_CONFIG = {
    rules: [
        {
            title: "One uppercase letter",
            regex: FRONT_REGEX_CONFIG.singleUpperLetter,
        },
        {
            title: "One number",
            regex: FRONT_REGEX_CONFIG.singleNumber,
        },
        {
            title: "One special character (! @ # $)",
            regex: FRONT_REGEX_CONFIG.singleSpecialCharacter,
        },
        {
            title: "At least 8 total characters",
            regex: /^.{8,}$/,
        },
    ] as IPasswordValidationRule[],
}

export const FRONT_VALIDATION_CONFIG = {
    required: "Field is required",
    minLength: {
        value: 2,
        message: "Field must have at least 2 characters",
    },
    maxLength: {
        value: 255,
        message: "Field must have maximum 255 characters",
    },
    maxLengthText: {
        value: 5000,
        message: "Field must have maximum 5000 characters",
    },
    minLengthPassword: {
        value: 8,
        message: "Password must have at least 8 characters",
    },
    maxLengthPassword: {
        value: 20,
        message: "Password must have maximum 20 characters",
    },
    email: {
        value: FRONT_REGEX_CONFIG.email,
        message: "Field must be a valid email",
    },
    zip: {
        value: FRONT_REGEX_CONFIG.zip,
        message: "Field must be a valid zip",
    },
    zipShort: {
        value: FRONT_REGEX_CONFIG.zipShort,
        message: "Field must be a valid zip",
    },
    minAmount0: {
        value: 0,
        message: "Minimum amount is 0",
    },
    minAmount: {
        value: 1,
        message: "Minimum amount is 1",
    },
    minPercentage: {
        value: 0,
        message: "Minimum amount is 0",
    },
    maxPercentage: {
        value: 100,
        message: "Minimum amount is 100",
    },
    npi: {
        value: FRONT_REGEX_CONFIG.npi,
        message: "NPI should consist of 10 digits",
    },
    taxId: {
        value: FRONT_REGEX_CONFIG.taxId,
        message: "Tax ID should consist of 9 digits",
    },
    ein: {
        value: FRONT_REGEX_CONFIG.ein,
        message: "EIN / SSN should consist of 9 digits",
    },
    einWithDash: {
        value: FRONT_REGEX_CONFIG.einWithDash,
        message: "EIN should be in valid format",
    },
    usPhoneNumber: {
        value: FRONT_REGEX_CONFIG.usPhoneNumber,
        message: "Valid US phone number should be provided",
    },
    integer: {
        value: FRONT_REGEX_CONFIG.integer,
        message: "Field must be a valid integer",
    },
    groupNpi: (data: string) =>
        !data ||
        data.match(FRONT_REGEX_CONFIG.npi) ||
        "NPI should consist of 10 digits or just leave it blank",
    date: (date: string) =>
        !date ||
        FRONT_REGEX_CONFIG.date.test(date) ||
        "Field must be a valid date on format MM/DD/YYYY",
    passwordSpecialValidations: {
        number: (data: string) =>
            !!data.match(FRONT_REGEX_CONFIG.singleNumber) ||
            "Password should contain a number",
        upperCase: (data: string) =>
            !!data.match(FRONT_REGEX_CONFIG.singleUpperLetter) ||
            "Password should contain an upper case letter",
        // lowerCase: (data: string) =>
        //     !!data.match(/[a-z]/) ||
        //     "Password should contain a lower case letter",
        specialCharacter: (data: string) =>
            !!data.match(FRONT_REGEX_CONFIG.singleSpecialCharacter) ||
            // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
            "Password should contain a special character from the following set: ^ $ * . [ ] { } ( ) ? \" ! @ # % & / , > < ' : ; | _ ~ ` = + -",
        minLength: (data: string) =>
            data.length >= 8 || "Password should be at least 8 characters long",
        maxLength: (data: string) =>
            data.length <= 20 ||
            "Password should be maximum 20 characters long",
    },
    databaseId: (data: string) =>
        !data || parseInt(data) > 0 || "Please select from available values",
}
